/* Odhad doručení JUSTLOVE – výpočet v čase Europe/Prague. Konfigurace: window.JLDeliveryConfig (snippets/delivery-estimate.liquid, Nastavení motivu > Odhad doručení). */
(function(){
  if (window.JLDelivery) return;
  var CFG = window.JLDeliveryConfig || {cutoff:'10:00', handling:0, transit:1, closures:'', longLead:'Šijeme pro Vás ručně v našem českém ateliéru, bude u Vás'};
  var TZ = 'Europe/Prague';
  var DAY = ['v neděli','v pondělí','v úterý','ve středu','ve čtvrtek','v pátek','v sobotu'];
  var DAY_DO = ['do neděle','do pondělí','do úterý','do středy','do čtvrtka','do pátku','do soboty'];
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function pragueParts(d){
    var o = {};
    new Intl.DateTimeFormat('en-GB',{timeZone:TZ,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'})
      .formatToParts(d).forEach(function(p){ o[p.type] = p.value; });
    return {y:+o.year, m:+o.month, d:+o.day, h:(+o.hour)%24, mi:+o.minute};
  }
  function U(y,m,d){ return new Date(Date.UTC(y,m-1,d)); }
  function addDays(dt,n){ return new Date(dt.getTime() + n*86400000); }
  function key(dt){ return dt.getUTCFullYear()+'-'+pad(dt.getUTCMonth()+1)+'-'+pad(dt.getUTCDate()); }
  function easter(y){ // anonymní gregoriánský algoritmus
    var a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),
        h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),
        mo=Math.floor((h+l-7*m+114)/31),da=((h+l-7*m+114)%31)+1;
    return U(y,mo,da);
  }
  var HCACHE = {};
  function holidays(y){
    if (HCACHE[y]) return HCACHE[y];
    var s = {};
    [[1,1],[5,1],[5,8],[7,5],[7,6],[9,28],[10,28],[11,17],[12,24],[12,25],[12,26]].forEach(function(x){ s[key(U(y,x[0],x[1]))] = 1; });
    var e = easter(y); s[key(addDays(e,-2))] = 1; s[key(addDays(e,1))] = 1; // Velký pátek, Velikonoční pondělí
    return (HCACHE[y] = s);
  }
  // Zavírací dny: řádky „24.12.–31.12.“ (bez roku = každý rok), „1.10.2026“ nebo „1.10.2026–2.10.2026“
  var RANGES = String(CFG.closures || '').split(/[\n;]+/).map(function(line){
    var m = line.replace(/\s+/g,'').match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})?(?:[-–—](\d{1,2})\.(\d{1,2})\.(\d{4})?)?$/);
    if (!m) return null;
    return {d1:+m[1], m1:+m[2], y1:m[3]?+m[3]:null, d2:m[4]?+m[4]:+m[1], m2:m[5]?+m[5]:+m[2], y2:m[6]?+m[6]:(m[4]?null:(m[3]?+m[3]:null))};
  }).filter(Boolean);
  function isClosed(dt){
    var y = dt.getUTCFullYear(), md = (dt.getUTCMonth()+1)*100 + dt.getUTCDate();
    for (var i=0;i<RANGES.length;i++){
      var r = RANGES[i];
      if (r.y1){
        var a = U(r.y1,r.m1,r.d1), b = U(r.y2 || r.y1, r.m2, r.d2);
        if (dt >= a && dt <= b) return true;
      } else {
        var s = r.m1*100 + r.d1, e = r.m2*100 + r.d2;
        if (s <= e ? (md >= s && md <= e) : (md >= s || md <= e)) return true;
      }
    }
    return false;
  }
  function carrierDay(dt){ var w = dt.getUTCDay(); return w !== 0 && w !== 6 && !holidays(dt.getUTCFullYear())[key(dt)]; }
  function warehouseDay(dt){ return carrierDay(dt) && !isClosed(dt); }
  function nextDay(dt,fn){ var x = addDays(dt,1), n = 0; while (!fn(x) && n++ < 400) x = addDays(x,1); return x; }
  function cutoffMin(){ var m = String(CFG.cutoff||'10:00').match(/(\d{1,2})(?:[:.](\d{2}))?/); return m ? (+m[1])*60 + (+(m[2]||0)) : 600; }
  function cutoffLabel(){ var c = cutoffMin(); return Math.floor(c/60) + ':' + pad(c%60); }
  // days <= 1: standard (expedice dnes / další den skladu + dny expedice + dny přepravy).
  // days >= 2 (šité v ateliéru, custom.delivery_days / štítek dodani-N-dni): doručení = N-tý pracovní den počítaný od dne,
  // kdy bychom běžně expedovali (stejná uzávěrka, svátky i zavírací dny skladu; N-1 dnů výroby ve skladu + 1 den přepravy).
  function compute(now, days){
    var p = pragueParts(now || new Date()), today = U(p.y,p.m,p.d), mins = p.h*60 + p.mi;
    var sameDay = warehouseDay(today) && mins < cutoffMin();
    var ship = sameDay ? today : nextDay(today, warehouseDay), del, i, n = Math.floor(+days || 0);
    if (n >= 2){
      for (i=0;i<n-1;i++) ship = nextDay(ship, warehouseDay);
      del = nextDay(ship, carrierDay);
    } else {
      for (i=0;i<(+CFG.handling||0);i++) ship = nextDay(ship, warehouseDay);
      del = ship;
      for (i=0;i<Math.max(1,+CFG.transit||1);i++) del = nextDay(del, carrierDay);
    }
    return {prague: p.y+'-'+pad(p.m)+'-'+pad(p.d)+' '+pad(p.h)+':'+pad(p.mi), sameDay: sameDay, days: n >= 2 ? n : 0, ship: key(ship), delivery: key(del), deliveryDate: del};
  }
  function dateLabel(dt, dow){ return (dow || DAY)[dt.getUTCDay()] + ' ' + dt.getUTCDate() + '.\u00a0' + (dt.getUTCMonth()+1) + '.'; }
  function parts(r, mixed){
    if (r.days) return {lead: (mixed ? 'Objednávka bude u Vás ' : (CFG.longLead || 'Šijeme pro Vás ručně v našem českém ateliéru, bude u Vás') + ' '), date: dateLabel(r.deliveryDate, DAY_DO)};
    return {lead: (r.sameDay ? 'Objednejte do ' + cutoffLabel() : 'Objednejte dnes') + ' a bude u Vás ', date: dateLabel(r.deliveryDate)};
  }
  function text(r, mixed){ var x = parts(r, mixed); return x.lead + x.date; }
  function html(r, mixed){ var x = parts(r, mixed); return x.lead + '<span class="jl-delivery__date">' + x.date + '</span>'; }
  function variantOf(el){
    var scope = el.closest('[data-wetheme-section-id], .shopify-section, section') || document;
    var btn = scope.querySelector('.product--add-to-cart-button'), form = btn && btn.closest('form');
    var inp = (form || scope).querySelector('[name="id"]') || scope.querySelector('form[action*="/cart/add"] [name="id"]');
    return (inp && inp.value) || el.getAttribute('data-jl-variant');
  }
  function update(){
    var now = new Date(), cache = {};
    document.querySelectorAll('[data-jl-delivery]').forEach(function(el){
      var show = true, days = +(el.getAttribute('data-jl-days') || 0), mixed = el.getAttribute('data-jl-mixed') === '1';
      if (el.getAttribute('data-jl-delivery') === 'product'){
        var map = {}; try { map = JSON.parse(el.getAttribute('data-jl-variants') || '{}'); } catch(e){}
        show = map[String(variantOf(el))] === 1;
      }
      var ck = days + '|' + mixed, h = cache[ck] || (cache[ck] = html(compute(now, days), mixed));
      var t = el.querySelector('.jl-delivery__text');
      if (t && t.innerHTML !== h) t.innerHTML = h;
      if (el.hidden === show) el.hidden = !show;
    });
  }
  window.JLDelivery = {compute: compute, text: text, update: update, config: CFG, holidays: holidays, isClosed: isClosed};
  update();
  var pend = false;
  new MutationObserver(function(){ if (pend) return; pend = true; setTimeout(function(){ pend = false; update(); }, 60); })
    .observe(document.body, {childList: true, subtree: true});
  document.addEventListener('change', function(){ setTimeout(update, 60); }, true);
  document.addEventListener('click', function(){ setTimeout(update, 150); }, true);
  setInterval(update, 30000); // přechod přes uzávěrku / půlnoc (bez odpočtu)
})();
